<script setup lang="ts">
    import {visibleNavigationChildren} from '~/lib/navigation';
    import {NuxtLink} from '#components';

    const props = defineProps(['item', 'open', 'isFetching', 'active', 'selectedPath', 'depth']);
    const emit = defineEmits(['update:open','navigate']);
    const manualOpen=ref<boolean|undefined>();
    const fullList=ref(false);
    const depth=computed(()=>Number(props.depth||0));
    function containsSelected(item){return item.access!==false&&(item.path===props.selectedPath||item.childrens?.some(containsSelected));}
    const branchActive=computed(()=>!!props.selectedPath&&containsSelected(props.item));
    const expanded=computed(()=>manualOpen.value??props.open??(!!props.item.alwaysVisibleChildren||branchActive.value));
    const children=computed(()=>props.item.childrens?.filter(item=>item.access!==false)||[]);
    const shown=computed(()=>depth.value>=1?visibleNavigationChildren(children.value,props.selectedPath,fullList.value):children.value);
    const current=computed(()=>props.selectedPath===props.item.path?(props.active?.path===props.item.path?'page':'location'):undefined);
    const bodyId=computed(()=>'uo-nav-'+encodeURIComponent(props.item.path));
    function toggle(){manualOpen.value=!expanded.value;emit('update:open',manualOpen.value);}
    function openBranch(){emit('navigate',props.item);if(children.value.length&&!props.item.alwaysVisibleChildren){manualOpen.value=true;emit('update:open',true);}}
    watch(()=>props.active?.path,()=>{manualOpen.value=undefined;fullList.value=false;});
    const checkAccess = (item) => item.hasOwnProperty('access') ? item.access : true
</script>

<template>
    <div class="uo-nav-node" v-if="checkAccess(item)">
        <div class="uo-nav-branch" :class="{'uo-nav-selected':current,'uo-nav-ancestor':children.length&&branchActive}">
        <NuxtLink :to="item.path" class="uo-nav-row" :aria-current="current" :aria-expanded="children.length&&!item.alwaysVisibleChildren?expanded:undefined" :aria-controls="children.length&&!item.alwaysVisibleChildren?bodyId:undefined" @click="openBranch">
                <template v-if="depth===0"><slot name="icon" v-bind="item">
                    <span class="text-xl" v-if="item.emoji">
                        {{ item.emoji }}
                    </span>      
                </slot></template>
                <span class="uo-nav-label">{{ item.title }}</span>
            <slot name="end" v-bind="item"></slot>
        </NuxtLink>
        <button v-if="children.length" class="uo-nav-toggle" type="button" :aria-label="(expanded?'Свернуть: ':'Раскрыть: ')+item.title" :aria-expanded="expanded" :aria-controls="bodyId" @click="toggle"><svg class="uo-nav-chevron" :class="{'uo-nav-chevron-open':expanded}" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="m9 5 7 7-7 7"/></svg></button>
        </div>
       
        <div class="uo-nav-children" v-if="children.length&&expanded" :id="bodyId">
            <Tree v-for="child in shown" :key="child.path" :item="child" :selected-path="selectedPath" :depth="depth+1" :active="active">
                <template #icon="slotItem">
                    <slot name="icon" v-bind="slotItem"></slot>
                </template>
                <template #end="slotItem">
                    <slot name="end" v-bind="slotItem"></slot>
                </template>
            </Tree>
            <button v-if="depth>=1&&children.length>10" class="uo-nav-expand" type="button" :aria-expanded="fullList" @click="fullList=!fullList">{{fullList?'Свернуть список':'Смотреть полный список'}} <span v-if="!fullList">({{children.length}})</span></button>
        </div>
    </div>
</template>
